module.exports = __webpack_public_path__ + "img/z4.2371bf48.png";